import { LabelHTMLAttributes, forwardRef } from 'react';
import { cn } from './cn';

export const Label = forwardRef<HTMLLabelElement, LabelHTMLAttributes<HTMLLabelElement>>(
  ({ className, ...props }, ref) => (
    <label
      ref={ref}
      className={cn('text-sm font-medium leading-none text-nova-foreground', className)}
      {...props}
    />
  )
);

Label.displayName = 'Label';
